import { Link } from "react-router-dom";
import { Btn, FeatherIcons, H5, H6, Image, LI, UL } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service";
import { Checkout, Href } from "../../../../utils/Constant";
import { Input, InputGroup } from "reactstrap";
import { cartsData } from "../../../../Data/Layout/HeaderData";
import { CartsType } from "../../../../Type/Layout/Header";
import { useState } from "react";

const CartBox = () => {
  const [cartData,setCartData] = useState(cartsData)
  const handleRemove = (data:CartsType) => {
    setCartData(cartData.filter((item)=>(item.userName !== data.userName)))
  }
  return (
    <UL>
      {cartData.map((data, index) => (
        <LI key={index}>
          <div className="d-flex">
            <Image className="img-fluid b-r-5 me-3 img-60" src={dynamicImage(`other-images/${data.img}`)} alt="cart" />
            <div className="flex-grow-1 f-w-600">
              <span>{data.userName}</span>
              <div className="qty-box">
                <InputGroup>
                  <span className="input-group-prepend">
                    <Btn className="quantity-left-minus"> -</Btn>
                  </span>
                  <Input className="input-number" type="text" name="quantity" defaultValue={1}/>
                  <span className="input-group-prepend">
                    <Btn className="quantity-right-plus">+ </Btn>
                  </span>
                </InputGroup>
              </div>
              <H5 className="font-primary">${data.amount}</H5>
            </div>
            <div className="close-circle">
              <Link className="bg-danger" to={Href} onClick={()=>handleRemove(data)}>
                <FeatherIcons iconName="X" />
              </Link>
            </div>
          </div>
        </LI>
      ))}
      <LI className="total">
        <H6 className="mb-0">
          Order Total : <span className="f-right">$1000.00</span>
        </H6>
      </LI>
      <LI className="text-center">
        <Link className="d-block mb-3 view-cart f-w-700" to={`${process.env.PUBLIC_URL}/ecommerce/cart`}>
          {"Go to your cart"}
        </Link>
        <Link className="btn btn-primary view-checkout" to={`${process.env.PUBLIC_URL}/ecommerce/checkout`}>
          {Checkout}
        </Link>
      </LI>
    </UL>
  );
};

export default CartBox;
